mutation AddFont($clientId: ID!, $font: InputFont!) {
    addFont(clientId: $clientId, font: $font) {
        _id
    }
}
